// src/array/chunk.ts
function chunk(list, chunkLength) {
  if (chunkLength < 1) {
    throw new Error("The chunk length must be a positive integer");
  }
  const chunks = [];
  let counter = 0;
  while (counter < list.length) {
    chunks.push(list.slice(counter, counter += chunkLength));
  }
  return chunks;
}

// src/array/groupBy.ts
function groupBy(list, keyGetter) {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
}

// src/array/intersperse.ts
function intersperse(list, separator) {
  let index = -1;
  const length = list.length;
  const result = [];
  while (++index < length) {
    if (index === length - 1) {
      result.push(list[index]);
    } else {
      result.push(list[index], separator);
    }
  }
  return result;
}

// src/array/maxBy.ts
function maxBy(list, comparator) {
  let maxIndex = 0;
  let maxValue = null;
  for (let index = 0; index < list.length; index++) {
    const result = comparator(list[index]);
    if (maxValue === null || maxValue < result) {
      maxValue = result;
      maxIndex = index;
    }
  }
  return list[maxIndex];
}

// src/array/toggle.ts
function toggle(list, value) {
  if (list.includes(value)) {
    return list.filter((item) => item !== value);
  }
  return [...list, value];
}

// src/array/uniq.ts
function uniq(list) {
  let index = -1;
  const result = [];
  while (++index < list.length) {
    const value = list[index];
    if (!result.includes(value)) {
      result.push(value);
    }
  }
  return result;
}

// src/array/without.ts
function without(list, values) {
  return list.reduce((acc, value) => values.includes(value) ? acc : acc.concat(value), []);
}
export {
  chunk,
  groupBy,
  intersperse,
  maxBy,
  toggle,
  uniq,
  without
};
